'use strict';

require('../../style/index.css');

require('./index.css');

require('../../select/style/css');

require('../../input/style/css');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.13.2@antd/lib/pagination/style/css.js
// module id = 1027
// module chunks = 0